export const WEATHER_FILL = {
  moderate_rain: { fillColor: "#3b82f6", fillOpacity: 0.28, strokeColor: "#2563eb", strokeOpacity: 0.50, strokeWeight: 1 },
  heavy_rain:    { fillColor: "#1d4ed8", fillOpacity: 0.38, strokeColor: "#1e40af", strokeOpacity: 0.60, strokeWeight: 1 },
  light_rain:    { fillColor: "#93c5fd", fillOpacity: 0.18, strokeColor: "#3b82f6", strokeOpacity: 0.30, strokeWeight: 1 },
  fog:           { fillColor: "#94a3b8", fillOpacity: 0.32, strokeColor: "#64748b", strokeOpacity: 0.45, strokeWeight: 1 },
  cloudy:        { fillColor: "#e2e8f0", fillOpacity: 0.08, strokeColor: "#94a3b8", strokeOpacity: 0.15, strokeWeight: 1 },
};

export const WEATHER_FILL_FALLBACK = {
  fillColor: "#e2e8f0", fillOpacity: 0.06, strokeColor: "#94a3b8", strokeOpacity: 0.12, strokeWeight: 1,
};

export const TRAFFIC_FLOW_COLORS = {
  free_flow: "#22c55e",
  slow:      "#f59e0b",
  congested: "#ef4444",
};

export function getOBUBadgeColor(latencyMs) {
  if (latencyMs < 50) return "#22c55e";
  if (latencyMs < 100) return "#f59e0b";
  return "#ef4444";
}

export function getSegmentMidpoint(path) {
  if (!path?.length) return null;
  return path[Math.floor(path.length / 2)];
}

export function createBadgeIcon(latencyMs, maps) {
  const color = getOBUBadgeColor(latencyMs);
  const label = `${latencyMs}ms`;
  const w = 16 + label.length * 7;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="22">
    <rect width="${w}" height="22" rx="5" fill="#111827" opacity="0.88"/>
    <circle cx="9" cy="11" r="4" fill="${color}"/>
    <text x="17" y="15" font-family="monospace,sans-serif" font-size="10" font-weight="700" fill="#f9fafb">${label}</text>
  </svg>`;
  return {
    url: "data:image/svg+xml," + encodeURIComponent(svg),
    scaledSize: new maps.Size(w, 22),
    anchor: new maps.Point(w / 2, 11),
  };
}
